// v-copy="data"  默认复制成功后弹出提示
// v-copy:noInfo="data" 不显示复制成功后的提示
import { useClipboard } from '@vueuse/core'

const copy = {
  mounted: function (el, binding) {
    el.copyData = binding.value
    const { copy } = useClipboard({ source: binding.value })
    const { modifiers } = binding
    const handleClick = () => {
      copy(el.copyData)

      if (!modifiers.noInfo) {
        ElMessage.success('复制成功')
      }
    }
    el.addEventListener('click', handleClick)
    el.__handleClick = handleClick
  },
  updated: function (el, binding) {
    el.copyData = binding.value
  },
  beforeUnmount: function (el) {
    el.removeEventListener('click', el.__handleClick)
  }
}

export default copy